'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative overflow-hidden bg-gradient-to-br from-primary to-secondary ${className}`}>
      <div className="absolute inset-0">
        <div className="absolute inset-0 scale-[1.03] bg-[url('/assets/images/background.webp')] bg-cover bg-center blur-[1.5px]" />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/88 via-primary/82 to-secondary/88" />
        <div className="absolute inset-0 bg-black/10" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 py-16 lg:px-6 lg:py-24">
        <div className="flex max-w-3xl flex-col justify-center">
          <div className="mb-4 inline-flex w-fit items-center gap-2 rounded-full bg-white/12 px-4 py-2 backdrop-blur-sm">
            <Icon name="TruckIcon" size={20} className="text-white" />
            <span className="font-caption text-sm font-medium text-white">
              Оптовые поставки по всему Казахстану
            </span>
          </div>

          <h1 className="mb-6 font-heading text-4xl font-bold leading-tight text-primary-foreground lg:text-5xl drop-shadow-lg">
            Оптовые закупки товаров народного потребления
          </h1>

          <p className="mb-8 rounded-lg bg-black/25 p-4 text-lg leading-relaxed text-white drop-shadow-md backdrop-blur-[1px] lg:text-xl">
            Подайте заявку на оптовую закупку товаров для вашего бизнеса. Широкий ассортимент
            бытовой химии, средств гигиены и товаров для дома с выгодными ценами при покупке
            упаковками и коробками.
          </p>

          <div className="flex flex-col gap-4 sm:flex-row">
            <Link
              href="/product-catalog"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-accent px-6 py-3 font-heading text-base font-medium text-accent-foreground shadow-md transition-all duration-250 hover:-translate-y-0.5 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-accent-foreground focus:ring-offset-2 active:scale-[0.97]"
            >
              <span>Смотреть каталог</span>
              <Icon name="ArrowRightIcon" size={20} />
            </Link>

            <Link
              href="/shopping-cart"
              className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-primary-foreground/30 bg-primary-foreground/10 px-6 py-3 font-heading text-base font-medium text-primary-foreground backdrop-blur-sm transition-all duration-250 hover:-translate-y-0.5 hover:bg-primary-foreground/20 focus:outline-none focus:ring-2 focus:ring-primary-foreground focus:ring-offset-2 active:scale-[0.97]"
            >
              <Icon name="ShoppingCartIcon" size={20} />
              <span>Моя корзина</span>
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="mb-2 font-heading text-3xl font-bold text-primary-foreground">1000+</div>
              <div className="font-caption text-sm text-white">Товаров в каталоге</div>
            </div>

            <div className="text-center">
              <div className="mb-2 font-heading text-3xl font-bold text-primary-foreground">500+</div>
              <div className="font-caption text-sm text-white">Довольных клиентов</div>
            </div>

            <div className="text-center">
              <div className="mb-2 font-heading text-3xl font-bold text-primary-foreground">24/7</div>
              <div className="font-caption text-sm text-white">Прием заявок</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;